<template>
  <div class="tactic-page">
    <div v-if="showText" class="content">
      <p>
        <b>[ + </b><i>{{ tactic.name }}</i
        >&nbsp;<b>]</b>
      </p>
      <p>
        <br /><i>{{ tactic.text }}</i
        ><br />&mdash;
      </p>
    </div>

    <img
      v-if="tactic && !showText"
      :src="tactic.image_file_name"
      class="tactic-img"
    />

    <img-button
      src="icon-<.png"
      class="left-button"
      :disabled="!showText"
      @click="showText = false"
    ></img-button>

    <img-button
      src="icon->.png"
      class="right-button"
      :disabled="showText"
      @click="showText = true"
    ></img-button>

    <button class="close-button" @click="close">CLOSE</button>
  </div>
</template>

<script>
import ImgButton from "@/components/ImgButton.vue";
export default {
  components: { ImgButton },
  data() {
    return {
      showText: false,
    };
  },
  computed: {
    tactic: function () {
      if (this.$store.getters.tactics) {
        return this.$store.getters.tactics.find((t) => t.active);
      } else {
        return null;
      }
    },
  },
  methods: {
      close: function(){
          // reset to the image page when we close
          this.showText = false;

          this.$emit('close');
      }
  }
};
</script>

<style lang="scss">
.tactic-page {
  width: 768px;
  height: 768px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #000000;
  background-image: url("../assets/images/grid-white-x2.png");
  color: #f1ece6;
  z-index: 99;

  .content {
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 120px;
    font-size: 30px;
    font-weight: 100;
  }

  .tactic-img {
    position: absolute;
    top: 0;
    left: 0;
  }

  .left-button {
    position: absolute;
    bottom: 117px;
    left: 120px;
  }

  .right-button {
    position: absolute;
    bottom: 117px;
    left: 179px;
  }

  .close-button {
    position: absolute;
    bottom: 117px;
    right: 117px;
    width: 60px;
    height: 30px;
    cursor: pointer;
    font-size: 13px;
    line-height: 32px;
    background-color: #f1ece6;
    color: black;
    border: none;
    outline: none;
    animation: flickerAnimation 3s infinite;
  }
}
</style>
